import React from "react";
import { IControlStyles, useControlStyles } from "../.";
import { ComponentProps, ControlInput, ControlTemplateProps } from "../misc/controlInput";
import { ControlSwitchGlobalStyle } from "./controlSwitch.styled";

export interface ControlSwitchProps extends ControlTemplateProps {

}

export const ControlSwitch: React.FC<ControlSwitchProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ?? useControlStyles();

    return (
        <>
            <ControlSwitchGlobalStyle />
            <ControlInput type="switch" {...ComponentProps(props)} style={{ ...styles.switch ?? styles.checkbox ?? styles.radio ?? styles.input, ...props.style }} />
        </>
    );
};